import { TranslationCustomerMessages, CustomerMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationCustomerMessages = {
  [CustomerMessages.applicationDashboard]: "Dashboard",
  [CustomerMessages.applicationConcretingRequest]: "Concreting request",
  [CustomerMessages.applicationConcretingRequestAbbreviated]: "Concreting request",
  [CustomerMessages.applicationContract]: "Contracts",
  [CustomerMessages.applicationConcreting]: "Concretings",
  [CustomerMessages.applicationInvoice]: "Invoices",
  [CustomerMessages.applicationConcretingApproval]: "Concreting approval",
  [CustomerMessages.applicationCertificate]: "Certificates",
  [CustomerMessages.applicationClient]: "Clients",
  [CustomerMessages.applicationPermission]: "Permissions",
  [CustomerMessages.applicationLogout]: "Logout",
  [CustomerMessages.applicationSettings]: "Settings",
  [CustomerMessages.allUsersStatusIconTitle]: "All users",
  [CustomerMessages.newUsersStatusIconTitle]: "New users",
  [CustomerMessages.activeUsersStatusIconTitle]: "Active users",
  [CustomerMessages.inactiveUsersStatusIconTitle]: "Inactivated users",
  [CustomerMessages.blockedUsersStatusIconTitle]: "Blocked users",
  [CustomerMessages.inactivedUser]: "User inactivated",
  [CustomerMessages.activedUser]: "User activated",
  [CustomerMessages.errorInactivatingUser]: "Error when inactivating user",
  [CustomerMessages.errorActivatingUser]: "Error activating user",
  [CustomerMessages.inactivateUserTitle]: "Inactivate user",
  [CustomerMessages.activateUserTitle]: "Activate user",
  [CustomerMessages.inactivateUserText]: "Do you want to inactivate <USER_NAME> user?",
  [CustomerMessages.activateUserText]: "Do you want to activate <USER_NAME> user?",
  [CustomerMessages.inactivateUserButton]: "Inactivate",
  [CustomerMessages.activateUserButton]: "Activate"
};
